import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import classes from "./questionnaire.module.css";

// Canonical "Иное" submit value (maps to Google Forms __other_option__). Do not translate.
const OTHER_VALUE = "Иное";

const GOOGLE_FORM_ACTION =
    "https://docs.google.com/forms/d/e/1FAIpQLSeYIabTyCGSOHldHE_CrbgX3qDKbjzU8euW3gb5yG765gCHYQ/formResponse";

const GOOGLE_FORM_LINK = "https://forms.gle/mbPvCnVdxECdMSwf6";
const RESULTS_PAGE_LINK = "/results";

const FIELD_IDS = {
    email: "entry.1412481037",
    q1: "entry.1309770283",
    q2: "entry.1449590649",
    q3: "entry.1451088487",
    q4: "entry.1201924683",
    q5: "entry.1329816303",
    q6: "entry.1767645503",
    q7: "entry.521427938",
    q8: "entry.2106180301",
    q9: "entry.1374919058",
    q10: "entry.1094223737",
    profile: "entry.1037739192",
};

// Canonical question/option data. `option` values are the exact strings POSTed to
// Google Forms — DO NOT translate them. The `labelKey` is used only for display via i18n.
const QUESTIONS_DATA = [
    {
        key: "q1",
        options: [
            "Да, хочу понять, как цифровизация улучшает взаимодействие между потребителем и контролирующей организацией. / Иә, цифрландыру тұтынушы мен бақылаушы ұйым арасындағы өзара әрекеттестікті қалай жақсартатынын түсінгім келеді.",
            "Интересно узнать, какие процессы можно автоматизировать с её помощью. / Оның көмегімен қандай процестерді автоматтандыруға болатынын білгім келеді.",
            "Полезно понять, как это повышает прозрачность, скорость обмена информацией и качество принятия решений. / Бұл ақпарат алмасудың ашықтығын, жылдамдығын және шешім қабылдау сапасын қалай арттыратынын түсіну пайдалы.",
            OTHER_VALUE,
        ],
    },
    {
        key: "q2",
        options: [
            "Да, хочу понять, какие цифровые инструменты используются для количественной оценки водных ресурсов. / Иә, су ресурстарының көлемін сандық бағалау үшін қандай цифрлық құралдар қолданылатынын түсінгім келеді.",
            "Интересно узнать, как цифровизация способствует формированию управленческих решений в сфере водных ресурсов. / Цифрландыру су ресурстары саласында басқарушылық шешімдер қабылдауға қалай ықпал ететінін білгім келеді.",
            "Полезно понять, как цифровые инструменты повышают обоснованность управленческих решений. / Цифрлық құралдар басқарушылық шешімдердің негізділігін қалай арттыратынын түсіну пайдалы.",
            OTHER_VALUE,
        ],
    },
    {
        key: "q3",
        options: [
            "Хочу понять различия между методами измерения. / Өлшеу әдістерінің айырмашылықтарын түсінгім келеді.",
            "Интересно узнать об акустических и скоростных методах. / Акустикалық және жылдамдық әдістері туралы білгім келеді.",
            "Полезно понять, как выбрать метод для точных расчётов. / Дәл есептеулер үшін әдісті қалай таңдау керектігін түсіну пайдалы.",
            OTHER_VALUE,
        ],
    },
    {
        key: "q4",
        options: [
            "Хочу понять, какие данные необходимы для принятия решений. / Шешім қабылдау үшін қандай деректер қажет екенін түсінгім келеді.",
            "Интересно узнать, как работает автоматическое регулирование в режиме реального времени. / Нақты уақыт режимінде автоматты реттеу қалай жұмыс істейтінін білгім келеді.",
            "Полезно понять, как это повышает надёжность эксплуатации сооружений. / Бұл құрылыстарды пайдалану сенімділігін қалай арттыратынын түсіну пайдалы.",
            OTHER_VALUE,
        ],
    },
    {
        key: "q5",
        options: [
            "Хочу понять, какие данные используются и как учитывается неопределённость. / Қандай деректер қолданылатынын және белгісіздік қалай ескерілетінін түсінгім келеді.",
            "Интересно узнать, как моделирование выявляет тенденции и риски. / Модельдеу үрдістер мен тәуекелдерді қалай анықтайтынын білгім келеді.",
            "Полезно понять, как результаты моделей помогают управлять ресурсами. / Модель нәтижелерінің ресурстарды басқаруға қалай көмектесетінін түсіну пайдалы.",
            OTHER_VALUE,
        ],
    },
    {
        key: "q6",
        options: [
            "Хочу понять, какие факторы влияют на водообеспеченность. / Өңірдің сумен қамтамасыз етілуіне қандай факторлар әсер ететінін түсінгім келеді.",
            "Интересно узнать, как сравниваются различные сценарии развития ситуации. / Жағдай дамуының әртүрлі сценарийлері қалай салыстырылатынын білгім келеді.",
            "Полезно понять, как результаты сценарного анализа помогают принимать долгосрочные решения. / Сценарийлік талдау нәтижелерінің ұзақ мерзімді шешімдер қабылдауға қалай көмектесетінін түсіну пайдалы.",
            OTHER_VALUE,
        ],
    },
    {
        key: "q7",
        options: [
            "Хочу понять, как моделирование выявляет риски дефицита воды. / Модельдеу су тапшылығы тәуекелдерін қалай анықтайтынын түсінгім келеді.",
            "Интересно узнать, как формируются сценарии распределения ресурсов. / Ресурстарды бөлу сценарийлері қалай құрылатынын білгім келеді.",
            "Полезно понять, как прогнозные расчёты корректируют планы водопользования. / Болжамдық есептеулер су пайдалану жоспарларын қалай түзететінін түсіну пайдалы.",
            OTHER_VALUE,
        ],
    },
    {
        key: "q8",
        options: [
            "Хочу понять, какие параметры контролируются. / Қандай параметрлер бақыланатынын түсінгім келеді.",
            "Интересно узнать, как автоматизация позволяет оперативно реагировать на изменения. / Автоматтандыру өзгерістерге жедел әрекет етуге қалай мүмкіндік беретінін білгім келеді.",
            "Полезно понять, как это повышает устойчивость водораспределительной инфраструктуры. / Бұл су тарату инфрақұрылымының орнықтылығын қалай арттыратынын түсіну пайдалы.",
            OTHER_VALUE,
        ],
    },
    {
        key: "q9",
        options: [
            "Хочу понять, как объединяются данные гидропостов, метеонаблюдений и полевых измерений. / Гидрологиялық бекеттер, метеобақылаулар және далалық өлшеулер деректері қалай біріктірілетінін түсінгім келеді.",
            "Интересно узнать, как анализируются пространственно-временные изменения. / Кеңістіктік-уақыттық өзгерістер қалай талданатынын білгім келеді.",
            "Полезно понять, как комплексный анализ повышает точность принимаемых решений. / Кешенді талдаудың қабылданған шешімдердің дәлдігін қалай арттыратынын түсіну пайдалы.",
            OTHER_VALUE,
        ],
    },
    {
        key: "q10",
        options: [
            "Хочу понять, какие программные решения и алгоритмы применяются для анализа распределения воды между потребителями. / Су таратудағы үлесті талдау үшін қандай бағдарламалық шешімдер мен алгоритмдер қолданылатынын түсінгім келеді.",
            "Интересно узнать, какие критерии и метрики используются для оценки эффективности распределения. / Бөлу тиімділігін бағалау үшін қандай критерийлер мен метрикалар қолданылатынын білгім келеді.",
            "Полезно понять, как аналитические инструменты помогают выявлять дисбаланс и оптимизировать распределение ресурсов. / Аналитикалық құралдар дисбалансты анықтауға және ресурстарды оңтайландыруға қалай көмектесетінін түсіну пайдалы.",
            OTHER_VALUE,
        ],
    },
];

// Build display model: keeps canonical `value` for submission/state, adds translated `label`.
const buildQuestions = (t) =>
    QUESTIONS_DATA.map((q) => ({
        key: q.key,
        title: t(`questionnaire.${q.key}.text`),
        options: q.options.map((value, idx) => ({
            value,
            label: value === OTHER_VALUE ? t("questionnaire.other") : t(`questionnaire.${q.key}.opt${idx + 1}`),
        })),
    }));

// Canonical profile submit values (POSTed to Google Forms — do not translate).
const PROFILE_OPTIONS_DATA = [
    { value: "Производственный инженер/Өндіріс инженері", labelKey: "questionnaire.profile.opt1" },
    { value: "Молодой специалист/Жас маман", labelKey: "questionnaire.profile.opt2" },
    { value: "Исследователь/Зерттеуші", labelKey: "questionnaire.profile.opt3" },
    { value: OTHER_VALUE, labelKey: "questionnaire.other" },
];

const buildProfileOptions = (t) =>
    PROFILE_OPTIONS_DATA.map((o) => ({ value: o.value, label: t(o.labelKey) }));

const initialOther = {
    q1: "", q2: "", q3: "", q4: "", q5: "",
    q6: "", q7: "", q8: "", q9: "", q10: "",
    profile: "",
};

const initialAnswers = {
    q1: "", q2: "", q3: "", q4: "", q5: "",
    q6: "", q7: "", q8: "", q9: "", q10: "",
};

function ActionButtons() {
    const { t } = useTranslation();
    return (
        <div className={classes.buttons}>
            <a
                href={GOOGLE_FORM_LINK}
                target="_blank"
                rel="noreferrer"
                className={classes.pillButton}
            >
                {t("questionnaire.openGoogleForm")}
            </a>
            <a href={RESULTS_PAGE_LINK} className={classes.pillButton}>
                {t("questionnaire.resultsLink")}
            </a>
        </div>
    );
}

const QuestionnairePage = () => {
    const { t } = useTranslation();
    const questions = buildQuestions(t);
    const profileOptions = buildProfileOptions(t);

    const [formData, setFormData] = useState({
        email: "",
        answers: { ...initialAnswers },
        profile: [],
        otherText: { ...initialOther },
    });

    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleAnswerChange = (key, value) => {
        setFormData((prev) => ({
            ...prev,
            answers: { ...prev.answers, [key]: value },
        }));
    };

    const handleOtherChange = (key, value) => {
        setFormData((prev) => ({
            ...prev,
            otherText: { ...prev.otherText, [key]: value },
        }));
    };

    const handleProfileChange = (value) => {
        setFormData((prev) => {
            const exists = prev.profile.includes(value);
            return {
                ...prev,
                profile: exists
                    ? prev.profile.filter((item) => item !== value)
                    : [...prev.profile, value],
            };
        });
    };

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

    const validateForm = () => {
        if (!formData.email.trim()) {
            alert(t("questionnaire.validation.emailRequired"));
            return false;
        }
        if (!validateEmail(formData.email)) {
            alert(t("questionnaire.validation.emailInvalid"));
            return false;
        }
        for (const question of questions) {
            const value = formData.answers[question.key];
            if (!value) {
                alert(t("questionnaire.validation.answerAll"));
                return false;
            }
            if (value === OTHER_VALUE && !formData.otherText[question.key].trim()) {
                alert(t("questionnaire.validation.fillOther"));
                return false;
            }
        }
        if (!formData.profile.length) {
            alert(t("questionnaire.validation.profileRequired"));
            return false;
        }
        if (
            formData.profile.includes(OTHER_VALUE) &&
            !formData.otherText.profile.trim()
        ) {
            alert(t("questionnaire.validation.fillOtherProfile"));
            return false;
        }
        return true;
    };

    const resetForm = () => {
        setFormData({
            email: "",
            answers: { ...initialAnswers },
            profile: [],
            otherText: { ...initialOther },
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setSubmitting(true);
        setSuccess(false);

        try {
            const payload = new FormData();
            payload.append(FIELD_IDS.email, formData.email.trim());

            questions.forEach((question) => {
                const selected = formData.answers[question.key];
                if (selected === OTHER_VALUE) {
                    payload.append(FIELD_IDS[question.key], "__other_option__");
                    payload.append(
                        `${FIELD_IDS[question.key]}.other_option_response`,
                        formData.otherText[question.key].trim()
                    );
                } else {
                    payload.append(FIELD_IDS[question.key], selected);
                }
            });

            formData.profile.forEach((item) => {
                if (item === OTHER_VALUE) {
                    payload.append(FIELD_IDS.profile, "__other_option__");
                    payload.append(
                        `${FIELD_IDS.profile}.other_option_response`,
                        formData.otherText.profile.trim()
                    );
                } else {
                    payload.append(FIELD_IDS.profile, item);
                }
            });

            await fetch(GOOGLE_FORM_ACTION, {
                method: "POST",
                mode: "no-cors",
                body: payload,
            });

            setSuccess(true);
            resetForm();
            window.scrollTo({ top: 0, behavior: "smooth" });
        } catch (error) {
            console.error(error);
            alert(t("questionnaire.submitError"));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <Header />
            <div className={classes.wrapper}>
                <div className={classes.container}>
                    <div className={classes.card}>
                        <span className={classes.badge}>{t("questionnaire.badge")}</span>
                        <h1 className={classes.title}>{t("questionnaire.title")}</h1>

                        <ActionButtons />

                        <div className={classes.intro}>
                            <IntlMessage id="questionnaire.intro" />
                        </div>

                        {success && (
                            <div className={classes.success}>
                                {t("questionnaire.successMessage")}
                            </div>
                        )}

                        <form className={classes.form} onSubmit={handleSubmit}>
                            <div className={classes.block}>
                                <h3 className={classes.blockTitle}>
                                    {t("questionnaire.emailLabel")}
                                </h3>
                                <input
                                    type="email"
                                    className={classes.input}
                                    placeholder="example@mail.com"
                                    value={formData.email}
                                    onChange={(e) =>
                                        setFormData((prev) => ({ ...prev, email: e.target.value }))
                                    }
                                />
                            </div>

                            {questions.map((question) => (
                                <div className={classes.block} key={question.key}>
                                    <h3 className={classes.blockTitle}>{question.title}</h3>
                                    <div className={classes.optionsList}>
                                        {question.options.map((option) => {
                                            const checked = formData.answers[question.key] === option.value;
                                            const isOther = option.value === OTHER_VALUE;
                                            return (
                                                <div key={option.value}>
                                                    <label className={classes.optionCard}>
                                                        <input
                                                            type="radio"
                                                            name={question.key}
                                                            value={option.value}
                                                            checked={checked}
                                                            onChange={() =>
                                                                handleAnswerChange(question.key, option.value)
                                                            }
                                                        />
                                                        <span>{option.label}</span>
                                                    </label>
                                                    {isOther && checked && (
                                                        <input
                                                            type="text"
                                                            className={`${classes.input} ${classes.otherInput}`}
                                                            placeholder={t("questionnaire.otherPlaceholder")}
                                                            value={formData.otherText[question.key]}
                                                            onChange={(e) =>
                                                                handleOtherChange(question.key, e.target.value)
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            ))}

                            <div className={classes.block}>
                                <h3 className={classes.blockTitle}>
                                    {t("questionnaire.profileLabel")}
                                </h3>
                                <div className={classes.optionsList}>
                                    {profileOptions.map((option) => {
                                        const checked = formData.profile.includes(option.value);
                                        const isOther = option.value === OTHER_VALUE;
                                        return (
                                            <div key={option.value}>
                                                <label className={classes.optionCard}>
                                                    <input
                                                        type="checkbox"
                                                        checked={checked}
                                                        onChange={() => handleProfileChange(option.value)}
                                                    />
                                                    <span>{option.label}</span>
                                                </label>
                                                {isOther && checked && (
                                                    <input
                                                        type="text"
                                                        className={`${classes.input} ${classes.otherInput}`}
                                                        placeholder={t("questionnaire.otherPlaceholder")}
                                                        value={formData.otherText.profile}
                                                        onChange={(e) =>
                                                            handleOtherChange("profile", e.target.value)
                                                        }
                                                    />
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className={classes.actions}>
                                <button
                                    type="submit"
                                    className={classes.submit}
                                    disabled={submitting}
                                >
                                    {submitting ? t("questionnaire.submitting") : t("questionnaire.submit")}
                                </button>
                            </div>
                        </form>

                        <ActionButtons />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default QuestionnairePage;
